import React, { useEffect, useState } from "react";
import Header from "../../layout/header/Header";
import { Grid, Button, Box, Typography } from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import { useHistory, useParams } from "react-router-dom";
import TextFieldInput from "../../components/TextFieldInput";
import SelectInput from "../../components/SelectInput";
import { Helmet } from "react-helmet";
import { clearVoucherLinkState, createVoucherLink, getChannelPartnerById } from "./new-cp-form.slice";
import { useDispatch, useSelector } from "react-redux";
import { COMPARE_VALUE } from "../../config/constant";
import "./NewChannelPartnerForm.scss";
import Loader from "../../components/Loader";
import SnackbarAlert from "../../shared-components/snackbar-alert/SnackbarAlert";
import {RHFPhoneInput} from "../../shared-components/phone-input/RHFPhoneInput"
import { isValidPhoneNumberWithRules } from "../../utilis/common-funtions";

export default function NewChannelPartnerForm() {
  const [copied, setCopied] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [snackbarConfig, setSnackbarConfig] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const { channelpartnerId } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  
  const { generatedLink, isLoading } = useSelector(
    (state) => state.voucherLink
  );

  const formik = useFormik({
    initialValues: {
      salutation: "Mr.",
      firstName: "",
      lastName: "",
      contactNumber: "",
      email: "",
      countryCode: "",
    },
    validationSchema: yup.object().shape({
      salutation: yup.string().required("Salutaiton is required"),
      firstName: yup
        .string()
        .required("First Name is required")
        .min(2, "First Name must be at least 2 characters"),
      lastName: yup
        .string()
        .required("Last Name is required")
        .min(2, "Last Name must be at least 2 characters"),

      contactNumber: yup
        .string()
        .required("Contact Number is required")
        .test(
          "is-valid-phone",
          "Contact Number is invalid",
          (value, context) => {
            const { contactNumber, countryCode } = context.parent;
            return isValidPhoneNumberWithRules(countryCode, contactNumber);
          }
        ),
      email: yup
        .string()
        .matches(
          /^[\w.%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
          "Please enter a valid email address"
        )
        .required("Email Address is required"),
    }),
    onSubmit: async (values) => {
      try {
        const payload = {
          firstName: values.firstName,
          lastName: values.lastName,
          contactNumber: values.contactNumber,
          countryCode: values.countryCode,
          emailId: values.email,
          channelPartnerLinkId: channelpartnerId,
        };

        const resultAction = await dispatch(createVoucherLink(payload))

        if (createVoucherLink.fulfilled.match(resultAction)) {
          setIsDisabled(true);
        }
       else if (createVoucherLink.rejected.match(resultAction)) {
         const errorMsg = resultAction?.payload?.errors?.message || "Error creating Customer link"
          setSnackbarConfig({
            open: true,
            message: `Error creating Customer link: ${errorMsg}`,
            severity: "error",
          });
        }
      } catch (error) {
      }
    },
    validateOnChange: true,
  });

  useEffect(() => {
    if (channelpartnerId?.length > 0) {
      dispatch(getChannelPartnerById(channelpartnerId))
        .unwrap()
        .then((res) => {})
        .catch(() => {
          history.push("/404");
        });
    }
  }, [dispatch, channelpartnerId, history]);

  useEffect(() => {
    formik.validateForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik?.values]);

  useEffect(() => {
    dispatch(clearVoucherLinkState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channelpartnerId]);

  

  const handleCopy = () => {
    navigator.clipboard.writeText(generatedLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

   const handleSnackbarClose = () => {
    setSnackbarConfig({
      open: false,
      message: "",
      severity: "",
    });
  };

  const handleNameChange = (e, fieldName) => {
    let value = e.target.value;
    if (fieldName === "firstName") {
      value = value.replace(/[^A-Za-z\s]/g, "");   //Allow spaces for firstName
    } else {
      value = value.replace(/[^A-Za-z]/g, "");
    }
    formik.setFieldValue(fieldName, value);

    if (!formik.touched[fieldName]) {
      formik.setFieldTouched(fieldName, true);
    }
  };


  const handleCreateNew = () => {
    // formik.resetForm();
    // setIsDisabled(false);
    dispatch(clearVoucherLinkState());
    window.location.reload();
  };


  return (
    <>
    {isLoading && <Loader isLoading={isLoading} />}
    <div className="new-cp-form-container">
      <Helmet>
        <title>Voucher Form</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Header logo={COMPARE_VALUE?.Puravankara} showHamburger={false} />
      <Grid
        container
        spacing={0}
        sx={{
          p: 0,
          paddingLeft: {
            xs: "16px",
            sm: "16px",
            md: "16px",
            lg: "7%",
          },
          paddingRight: {
            xs: "16px",
            sm: "16px",
            md: "16px",
            lg: "7%",
          },
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            textAlign: { xs: "center", sm: "center", md: "center" },
            pt: { xs: "16px", sm: "30px", md: "36px" },
            pb: { xs: "16px", sm: "18px", md: "20px" },
          }}
        >
          <Typography
            sx={{
              color: "#1A407D",
              fontSize: { xs: "20px", sm: "20px", md: "24px" },
              fontWeight: "700",
              lineHeight: { xs: "28px", sm: "32px", md: "36px" },
              mb: { xs: 0.5, sm: 1, md: 1 },
            }}
          >
            Create Customer Link
          </Typography>
        </Grid>
      </Grid>

      <Box
        sx={{
          borderRadius: "8px",
          border: "1px solid rgba(26, 64, 125, 0.30)",
          padding: { xs: "24px", sm: "24px", lg: "24px" },
          marginLeft: { xs: "16px", sm: "16px", lg: "70px" },
          marginRight: { xs: "16px", sm: "16px", lg: "70px" },
          marginBottom: { xs: "50px", sm: "70px", lg: "70px" },
        }}
      >
        <form onSubmit={formik.handleSubmit} noValidate>
          <Box
            sx={{
              p: 3,
              m: { sm: 3 },
              boxShadow: "1px 1px 4px 1px #919EAB33",
              borderRadius: "16px",
              marginTop: {sm: "24px" },
            }}
          >
            <Grid container spacing={2.5}>
              {/* First Name */}
              <Grid item xs={12} sm={6}>
                <Typography sx={{
                      fontSize: {
                        xs: "13px",
                        sm: "13px",
                        md: "14px",
                        xl: "14px",
                      },
                      mb: 1,
                      fontWeight: "500",
                    }}>
                  First Name <span style={{ color: "red" }}>*</span>
                </Typography>
                <Box display="flex" gap={1} alignItems="flex-start">
                  <SelectInput
                    field={{
                      name: "salutation",
                      readonly: isDisabled,
                      options: [
                        { value: "Mr.", name: "Mr." },
                        { value: "Ms.", name: "Ms." },
                        { value: "Mrs.", name: "Mrs." },
                      ],
                    }}
                    formik={formik}
                  />

                  <Box sx={{width: "100%" }}>
                    <TextFieldInput
                      field={{
                        name: "firstName",
                        placeholder: "Enter First Name",
                        readonly: isDisabled,
                        handleOnChange: (e) => handleNameChange(e, "firstName"),
                      }}
                      formik={formik}
                    />
                  </Box>
                </Box>
              </Grid>

              {/* Last Name */}
              <Grid item xs={12} sm={6}>
                <TextFieldInput
                  field={{
                    label: "Last Name",
                    name: "lastName",
                    placeholder: "Enter Last Name",
                    required: true,
                    handleOnChange: (e) => handleNameChange(e, "lastName"),
                    readonly: isDisabled,
                  }}
                  formik={formik}
                />
              </Grid>

              {/* Contact Number */}
              <Grid item xs={12} sm={6}>
                <RHFPhoneInput
                   name="contactNumber"
                   countryCodeName="countryCode"
                   label="Contact Number"
                   country={formik?.values?.countryCode || "IN"}
                   formik={formik}
                   placeholder="Enter Contact Number"
                   required
                   disabled={isDisabled}
                   showDialCode={true}
                 />
              </Grid>

              {/* Email */}
              <Grid item xs={12} sm={6}>
                <TextFieldInput
                  field={{
                    label: "Email",
                    name: "email",
                    placeholder: "Enter Email",
                    required: true,
                    readonly: isDisabled,
                    handleOnChange: (e) => {
                      formik.setFieldValue("email", e.target.value);
                      if (!formik.touched.email)
                        formik.setFieldTouched("email", true);
                    },
                  }}
                  formik={formik}
                />
              </Grid>

              {/* Generate Link Button */}
              <Grid item xs={12}>
                <Box display="flex" justifyContent="flex-end">
                  {generatedLink ? (
                    <Button
                      size="large"
                      variant="contained"
                      sx={{
                        backgroundColor: "#1A407D",
                        textTransform: "none",
                        borderRadius: "8px",
                        "&:hover": {
                          backgroundColor: "#092552",
                        },
                      }}
                      onClick={handleCreateNew}
                    >
                      Create New Link
                    </Button>
                  ) : (
                    <Button
                      type="submit"
                      disabled={isDisabled || isLoading}
                      size="large"
                      variant="contained"
                      sx={{
                        backgroundColor: "#1A407D",
                        textTransform: "none",
                        borderRadius: "8px",
                        "&:hover": {
                          backgroundColor: "#092552",
                        },
                      }}
                    >
                      {isLoading ? "Generating..." : "Generate Link"}
                    </Button>
                  )}
                </Box>
              </Grid>

              {generatedLink && (
                <>
                  <Grid item xs={12} sm={6}>
                    <TextFieldInput
                      field={{
                        name: "generatedLink",
                        label: "Generated Link",
                        placeholder: "",
                        readonly: true,
                        value: generatedLink,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Button
                      size="large"
                      variant="contained"
                      sx={{
                        backgroundColor: "#1A407D",
                        textTransform: "none",
                        borderRadius: "8px",
                        "&:hover": {
                          backgroundColor: "#092552",
                        },
                        mt: { sm: 3.5 },
                      }}
                      onClick={handleCopy}
                    >
                      {copied ? "Copied!" : "Copy"}
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>
          </Box>
        </form>
      </Box>
    </div>

      <SnackbarAlert
        open={snackbarConfig.open}
        message={snackbarConfig.message}
        severity={snackbarConfig.severity}
        onClose={handleSnackbarClose}
      />
    </>
  );
}